import { useMemo } from 'react';

import { useCategories } from '../categories/categories.api';
import { useAgenda, useTransactions } from '../transactions/transactions.api';
import { useWallets } from '../wallets/wallets.api';
import { deriveDashboardSnapshot } from './dashboard-data';

export function useDashboardData(today: Date | string = new Date()) {
  const transactions = useTransactions();
  const wallets = useWallets();
  const categories = useCategories();
  const agenda = useAgenda();
  const dateKey = typeof today === 'string' ? today.slice(0, 10) : today.toISOString().slice(0, 10);
  const isPending = [transactions, wallets, categories, agenda].some((query) => query.isPending);
  const isFetching = [transactions, wallets, categories, agenda].some((query) => query.isFetching);
  const error = [transactions, wallets, categories, agenda].find(
    (query) => query.error !== null,
  )?.error;

  const refresh = async () => {
    await Promise.all([
      transactions.refetch(),
      wallets.refetch(),
      categories.refetch(),
      agenda.refetch(),
    ]);
  };

  const snapshot = useMemo(() => {
    if (
      transactions.data === undefined ||
      wallets.data === undefined ||
      categories.data === undefined ||
      agenda.data === undefined
    ) {
      return null;
    }

    return deriveDashboardSnapshot({
      agenda: agenda.data,
      categories: categories.data,
      today: dateKey,
      transactions: transactions.data,
      wallets: wallets.data,
    });
  }, [agenda.data, categories.data, dateKey, transactions.data, wallets.data]);

  return { error, isFetching, isPending, refresh, snapshot };
}
